import { combineReducers, Reducer } from "redux";

// reducer import
import customizationReducer, {
  CustomizationState,
} from "./customizationReducer";

// ==============================|| COMBINE REDUCER ||============================== //

export interface RootState {
  customization: CustomizationState;
}

const reducer = combineReducers({
  customization: customizationReducer,
}) as Reducer<RootState>;

export default reducer;
